/**
 * The `activeNoteKey`/`sourceModalNoteKey`/`data-note-key` a legacy note is keyed by. Shared
 * between `NoteNav`, `NoteViewer` and `SourceDocumentModal` -- previously duplicated verbatim in
 * all three.
 */
export function noteKey(note: CMxCommonApp.DecoratedNote): string {
  return String(note.document_id);
}
